import Rest from './Rest';

const Dushu = {
  partnerGetSummary: () => {
    const url = '/dushu/wanke/partner/data/summary';

    return Rest.get(url);
  },
  partnerGetStatistics: (type, day) => {
    const url = '/dushu/wanke/partner/data/statistics';
    const params = { type };
    if (type === 'hour') {
      params.date = `${day}T00:00:00Z`
    }

    return Rest.get(url, { params });
  },
  partnerGetAvailableOrderDate: () => {
    const url = '/dushu/wanke/partner/orders/date';

    return Rest.get(url);
  },
  partnerGetOrders: (date) => {
    const url = '/dushu/wanke/partner/orders';
    const params = { date };

    return Rest.get(url, { params });
  },
  exportProviderDailyReport: () => {
    const url = '/dushu/wanke/statistics/report';
    return Rest.get(url);
  },
  partnerUpdateSetting: (enablePaymentNotify) => {
    const url = '/dushu/wanke/partner/settings';
    const params = { enablePaymentNotify };

    return Rest.put(url, params);
  },
  partnerListUsers: (gender, isVip, pageSize, currentPage) => {
    const url = '/dushu/wanke/partner/users';
    const params = {
      gender, isVip,
      'pagination.pageSize': pageSize,
      'pagination.pageIndex': currentPage,
    };

    return Rest.get(url, { params });
  },
  getProviderStatisticsVisibleFilter: () => {
    return Rest.post('/dushu/wanke/statistics/filter');
  },
  getProviderStatisticsVisibleProviders: (params) => {
    return Rest.post('/dushu/wanke/statistics/providers', params);
  },
  getProvidersStatisticsSummary: (params) => {
    return Rest.post('/dushu/wanke/statistics/summary', params);
  },
  getProvidersStatisticsDetail: (params) => {
    return Rest.post('/dushu/wanke/statistics/detail', params);
  },

  getProvidersIncomeTargets: (params) => {
    return Rest.get('/dushu/wanke/providers/targets/income-targets', { params });
  },

  listShareTypeMetas: () => {
    return Rest.get('/dushu/wanke/share-types', {
      params: {
        'pagination.pageIndex': 1,
        'pagination.pageSize': 9999,
      }
    });
  },

  getProviderStatisticsRanked: (params) => {
    return Rest.post('/dushu/wanke/statistics/ranked', params);
  }
};

export default Dushu;
